module.exports = __webpack_public_path__ + "img/logo.54703e39.png";